import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { SOLUTIONS } from "@/data/content";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function Solutions() {
  return (
    <section id="solutions" className="relative py-20 lg:py-32 bg-[#04121f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading number="04" eyebrow="Aquaculture Solutions" title="High-tech systems, one integrated partner."
            subtitle="RAS-assisted shrimp and crab farming engineered for control, biosecurity and zero-waste production — alongside makhana pond cultivation." />
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SOLUTIONS.map((s, i) => (
            <motion.article
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#071728] hover:border-cyan-400/40 hover:-translate-y-1.5 transition-all duration-400"
              data-testid={`solution-card-${i}`}
            >
              <div className="relative h-52 overflow-hidden">
                <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071728] via-[#071728]/30 to-transparent" />
                <span className="absolute top-4 left-4 font-mono-tech text-xs text-cyan-300/90 glass rounded-full px-3 py-1">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl font-bold text-white">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                <button
                  onClick={() => scrollToId("contact")}
                  data-testid={`solution-learn-more-${i}`}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-cyan-300 hover:text-cyan-200 transition-colors"
                >
                  Learn More
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
